import React, { useEffect, useState } from "react";
import {
  IContextUserRoleType,
  useUserInformation,
} from "../context/userInformation/UserInformationContext";
import Spinner from "../components/spinner/Spinner";
import { useNavigate } from "react-router";

interface PrivateRouteProps {
  children: React.ReactElement | React.ReactElement[];
  preventAccessTo: IContextUserRoleType[];
}

export default function PrivateRoute({
  children,
  preventAccessTo,
}: PrivateRouteProps) {
  const navigate = useNavigate();
  const userInformation = useUserInformation();
  const [sholdPrventAccess, setShouldPreventAccess] = useState(false);

  useEffect(() => {
    for (const item of preventAccessTo) {
      if (userInformation.validateByRole(item)) {
        setShouldPreventAccess(true);
        break;
      }
    }
  }, [preventAccessTo, userInformation]);

  if (userInformation.roles.length <= 0) return <Spinner />;

  if (sholdPrventAccess) {
    navigate("/user");
    window.location.reload();
    return null;
  }

  return <>{children}</>;
}
